module.exports = __webpack_public_path__ + "img/Patch23-2.38da4e9c.webp";